import React, { useRef, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { addScaleCorrector, motion, useInView } from "framer-motion";
import { AnimatePresence } from "framer-motion";
import "./Page1.css";
import { trackSocialClick, trackInstallClick, trackTrailerClick, trackModalOpen } from '../utils/gtmTracking';

// Page1
import SpurpunkTitle from '../assets/images/Spurpunk-Title@.png';
import SkeletonFrame from '../assets/images/Skeleton-Frame@.png';
import TrailerRibbon from '../assets/images/Trailer-Ribbon@.png';
import DiscordNormal from '../assets/images/Discord_normal@.png';
import DiscordPressed from '../assets/images/Discord_pressed@.png';
import InstagramNormal from '../assets/images/Instagram_normal@.png';
import InstagramPressed from '../assets/images/Instagram_pressed@.png';
import YoutubeNormal from '../assets/images/Youtube_normal@.png';
import YoutubePressed from '../assets/images/Youtube_pressed@.png';
import XNormal from '../assets/images/X_normal@.png';
import XPressed from '../assets/images/X_pressed@.png';
import FacebookNormal from '../assets/images/Facebook_normal@.png';
import FacebookPressed from '../assets/images/Facebook_pressed@.png';
import Cactus1 from '../assets/images/map-cactus2-icon@.png';
import Compass from '../assets/images/compass-icon@.png';
import Grass from '../assets/images/map-grass-icon@.png';
import Cactus2 from '../assets/images/map-cactus-icon@.png';
import Page1DottedLine from '../assets/images/Page1_Dotteed_Line@.png';
import ArrowDown from '../assets/images/Arrow_Down@.png';
import PlayTrailerNormal from '../assets/images/PlayTrailer_normal@.png';
import PlayTrailerPressed from '../assets/images/PlayTrailer_pressed@.png';
import GooglePlayBtn from '../assets/images/GooglePlay_BTN@.png';
import AppleStoreBtn from '../assets/images/AppleStore_BTN@.png';
import Page1Landmass from '../assets/images/Page1_Landmass@.png';
import SpurpunkIcon from '../assets/images/Spurpunk_icon.png';
import Share from '../assets/images/Share.png';
import Download from '../assets/images/Download.png';
import Close from '../assets/images/Close.png';
// Importing video
import GameplayVideo from '../assets/videos/Gameplay_BurialGrounds_Clips_Better.mp4';


const Page1 = () => {
  const [pressedStates, setPressedStates] = useState({
    discord: false,
    instagram: false,
    youtube: false,
    x: false,
    facebook: false,
    playTrailer: false,
  });

  const handlePress = (key, timeout) => {
    setPressedStates((prevState) => ({
      ...prevState,
      [key]: true,
    }));
    setTimeout(() => {
      setPressedStates((prevState) => ({
        ...prevState,
        [key]: false,
      }));
    }, timeout);
  };

  const [showModal1, setShowModal1] = useState(false);
  const [showModal2, setShowModal2] = useState(false);

  return (

    
    <div className="g-0 page1">
      <div className="top-bar d-flex py-2 px-md-5 w-100 justify-content-between align-items-center">
        <div className="d-md-flex align-items-center gap-md-3 justify-content-start">
          <motion.img src={SpurpunkIcon} alt="Press Kit" className="presskit-btn" initial={{ opacity: 0, scale: 1.5 }}
            animate={{ opacity: 1, scale: 1 }} transition={{ duration: 1, ease: 'easeOut' }} />

          {/* Social Media Links */}
          <div className="d-md-flex justify-content-center d-none">
            <motion.img src={pressedStates.discord ? DiscordPressed : DiscordNormal} alt="Discord" className="social-btn mx-1"
              initial={{ y: -25, opacity: 0 }} animate={{ y: [-25, 20, 0], opacity: 1 }} style={{ transformOrigin: '50% 80%' }}
              transition={{ type: "spring", stiffness: 200, damping: 5 }} 
              onClick={() => {
                handlePress('discord', 200);
                trackSocialClick('discord');
              }} />
          <motion.a
            href="https://www.instagram.com/spurpunk_td?igsh=NTc4MTIwNjQ2YQ%3D%3D&utm_source=qr"
            target="_blank"
            rel="noopener noreferrer"
            className="mx-2"
            onClick={() => {
              handlePress('instagram', 200);
              trackSocialClick('instagram');
            }} // analytics
            initial={{ y: 25, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.15, ease: 'easeOut' }}
            whileTap={{ scale: 0.96 }}
          >
            <img
              src={pressedStates.instagram ? InstagramPressed : InstagramNormal}
              alt="Instagram"
              style={{ display: 'block', pointerEvents: 'none' }}
            />
          </motion.a>

            <motion.img src={pressedStates.youtube ? YoutubePressed : YoutubeNormal} alt="Youtube" className="social-btn mx-1"
              initial={{ y: -25, opacity: 0 }} animate={{ y: [-25, 20, 0], opacity: 1 }}
              transition={{ type: "spring", stiffness: 250, damping: 5 }} 
              onClick={() => {
                handlePress('youtube', 200);
                trackSocialClick('youtube');
              }} />

            <motion.img src={pressedStates.x ? XPressed : XNormal} alt="X" className="social-btn mx-1"
              initial={{ y: -25, opacity: 0 }} animate={{ y: [-25, 20, 0], opacity: 1 }}
              transition={{ type: "spring", stiffness: 250, damping: 5 }} 
              onClick={() => {
                handlePress('x', 200);
                trackSocialClick('x');
              }} />

          <motion.a
            href="https://www.facebook.com/gaming/easleydunngames"
            target="_blank"
            rel="noopener noreferrer"
            className="mx-2"
            onClick={() => {
              handlePress('facebook', 200);
              trackSocialClick('facebook');
            }} // analytics
            initial={{ y: 25, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.15, ease: 'easeOut' }}
            whileTap={{ scale: 0.96 }}
          >
            <img
              src={pressedStates.facebook ? FacebookPressed : FacebookNormal}
              alt="Facebook"
              style={{ display: 'block', pointerEvents: 'none' }}
            />
          </motion.a>
          </div>
        </div>
        <div className="d-md-flex d-none align-items-center gap-3 justify-content-end">
          <motion.p className="play-now justify-content-center" initial={{ y: -25, opacity: 0 }} animate={{ y: 5, opacity: 1 }} 
                    transition={{ duration: 0.25, ease: 'easeOut' }}>Play Now:</motion.p>

          <a href="https://play.google.com/store/apps/details?id=com.easleydunnproductions.spurpunk&hl=en_US&gl=US" 
             target="_blank" rel="noopener noreferrer"
             onClick={() => trackInstallClick('google_play', 'https://play.google.com/store/apps/details?id=com.easleydunnproductions.spurpunk&hl=en_US&gl=US')}>
            <motion.img
              src={GooglePlayBtn} alt="Google Play Store" className="playstore-btn"
              initial={{ opacity: 0, scale: 1.5 }} animate={{ opacity: 1, scale: 1 }} 
              transition={{ duration: 1, ease: 'easeOut' }} />
          </a>
          <a href="https://apps.apple.com/ge/app/spurpunk-td/id1487386202#?platform=iphone" 
             target="_blank" rel="noopener noreferrer"
             onClick={() => trackInstallClick('apple_app_store', 'https://apps.apple.com/ge/app/spurpunk-td/id1487386202#?platform=iphone')}>
            <motion.img
              src={AppleStoreBtn} alt="Apple App Store" className="appstore-btn"
              initial={{ opacity: 0, scale: 1.5 }} animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 1, ease: 'easeOut' }} />
          </a>
        </div>
        <div className="d-flex d-md-none px-2">
          <button class="share-btn p-0 bg-transparent border-0" onClick={() => {  
              setShowModal1(true); 
              trackModalOpen('social_share');
            }}>
            <img src={Share} alt="Share" className="share-icon" />
          </button>
          <button class="download-btn p-0 bg-transparent border-0" onClick={() => {  
              setShowModal2(true); 
              trackModalOpen('app_download');
            }}>
            <img src={Download} alt="Download" className="download-icon" />
          </button>
        </div>
        <Modal show={showModal1} onHide={() => setShowModal1(false)} size="sm" centered className="modal">
                
                <Modal.Body className="m-body justify-content-center d-flex flex-column align-items-center position-relative">
                  <button  className="close-btn p-0 bg-transparent border-0"  onClick={() => setShowModal1(false)} >
                    <img src={Close} alt="Close Button" className="close-icon"></img>
                  </button>
                  <motion.p className="d-flex follow-us justify-content-center align-items-center" initial={{ y: -25, opacity: 0 }} animate={{ y: 5, opacity: 1 }} 
                              transition={{ duration: 0.25, ease: 'easeOut' }}>Follow Us</motion.p>
                  <div className="d-flex justify-content-center align-items-center flex-wrap w-100">
                    
                    <motion.img src={pressedStates.discord ? DiscordPressed : DiscordNormal} alt="Discord" className="social-btn m-2"
                      initial={{ opacity: 0, scale: 1.5 }} animate={{ opacity: 1, scale: 1 }} style={{ transformOrigin: '50% 80%' }}
                      transition={{ duration: 1, ease: 'easeOut' }} 
                      onClick={() => {
                        handlePress('discord', 200);
                        trackSocialClick('discord');
                      }} />

                    <motion.img
                      src={pressedStates.instagram ? InstagramPressed : InstagramNormal}
                      alt="Instagram"
                      className="social-btn m-2"
                      initial={{ opacity: 0, scale: 1.5 }}
                      animate={{ opacity: 1, scale: 1 }}
                      transition={{ duration: 1, ease: 'easeOut' }}
                      onClick={() => {
                        handlePress('instagram', 200);          // existing press logic
                        trackSocialClick('instagram');          // existing tracking
                        // open Instagram page in a new tab
                        window.open('https://www.instagram.com/spurpunk_td?igsh=NTc4MTIwNjQ2YQ%3D%3D&utm_source=qr', '_blank', 'noopener,noreferrer');
                      }}
                    />

                    <motion.img src={pressedStates.youtube ? YoutubePressed : YoutubeNormal} alt="Youtube" className="social-btn m-2"
                      initial={{ opacity: 0, scale: 1.5 }} animate={{ opacity: 1, scale: 1 }}
                      transition={{ duration: 1, ease: 'easeOut' }} 
                      onClick={() => {
                        handlePress('youtube', 200);
                        trackSocialClick('youtube');
                      }} />
                  </div>
                  <div className="d-flex justify-content-center align-items-center flex-wrap w-100">

                    <motion.img src={pressedStates.x ? XPressed : XNormal} alt="X" className="social-btn m-2"
                      initial={{ opacity: 0, scale: 1.5 }} animate={{ opacity: 1, scale: 1 }}
                      transition={{ duration: 1, ease: 'easeOut' }} 
                      onClick={() => {
                        handlePress('x', 200);
                        trackSocialClick('x');
                      }} />

                    <motion.img
                      src={pressedStates.facebook ? FacebookPressed : FacebookNormal}
                      alt="Facebook"
                      className="social-btn m-2"
                      initial={{ opacity: 0, scale: 1.5 }}
                      animate={{ opacity: 1, scale: 1 }}
                      transition={{ duration: 1, ease: 'easeOut' }}
                      onClick={() => {
                        handlePress('facebook', 200);        // your existing press animation/logic
                        trackSocialClick('facebook');        // your tracking function
                        // open Facebook in a new tab
                        window.open('https://www.facebook.com/gaming/easleydunngames', '_blank', 'noopener,noreferrer');
                      }}
                    />
                  </div>
                </Modal.Body>
        </Modal>

        <Modal show={showModal2} onHide={() => setShowModal2(false)} size="lg" centered className="modal">
                
                <Modal.Body className="m-body m-body justify-content-center d-flex flex-column align-items-center position-relative">
                  <button  className="close-btn p-0 bg-transparent border-0"  onClick={() => setShowModal2(false)} >
                    <img src={Close} alt="Close Button" className="close-icon"></img>
                  </button>
                  <div className="d-flex flex-column align-items-center gap-3 justify-content-end">
                    <motion.p className="play-now justify-content-center" initial={{ y: -25, opacity: 0 }} animate={{ y: 5, opacity: 1 }} 
                              transition={{ duration: 0.25, ease: 'easeOut' }}>Play Now</motion.p>

                    <a href="https://play.google.com/store/apps/details?id=com.easleydunnproductions.spurpunk&hl=en_US&gl=US" 
                       target="_blank" rel="noopener noreferrer"
                       onClick={() => trackInstallClick('google_play', 'https://play.google.com/store/apps/details?id=com.easleydunnproductions.spurpunk&hl=en_US&gl=US')}>
                      <motion.img
                        src={GooglePlayBtn} alt="Google Play Store" className="playstore-btn"
                        initial={{ opacity: 0, scale: 1.5 }} animate={{ opacity: 1, scale: 1 }} 
                        transition={{ duration: 1, ease: 'easeOut' }} />
                    </a>
                    <a href="https://apps.apple.com/ge/app/spurpunk-td/id1487386202#?platform=iphone" 
                       target="_blank" rel="noopener noreferrer"
                       onClick={() => trackInstallClick('apple_app_store', 'https://apps.apple.com/ge/app/spurpunk-td/id1487386202#?platform=iphone')}>
                      <motion.img
                        src={AppleStoreBtn} alt="Apple App Store" className="appstore-btn"
                        initial={{ opacity: 0, scale: 1.5 }} animate={{ opacity: 1, scale: 1 }}
                        transition={{ duration: 1, ease: 'easeOut' }} />
                    </a>
                  </div>
                </Modal.Body>
        </Modal>
      </div>

      <div className="title-container">  
        <motion.video src={GameplayVideo} autoPlay loop muted playsInline className="background-video"
                      initial={{ opacity: 0 }} animate={{ opacity: 1 }}
                      transition={{ duration: 0.2, ease: 'easeOut' }} />
        
        <div className="container d-flex justify-content-center">
        <motion.img 
          src={SpurpunkTitle} alt="Spurpunk Title" className="spurpunk-title" 
          initial={{ y: -50, opacity: 0 }} animate={{ y: 0, opacity: [0.5, 1] }} 
          transition={{ duration: 1, ease: 'easeOut' }} />
        </div>

      </div>

      <div className="bottom-section position-relative d-flex justify-content-center align-items-center g-0">
          <motion.img src={Page1Landmass} alt="Landmass" className="p1-landmass" />
          <motion.img src={Cactus1} alt="Map Cactus 1" className="cactus1"
                      initial={{ y: 25, opacity: 0 }} animate={{ y: 0, opacity: 1 }} 
                      transition={{ delay: 0.5, duration: 1, ease: 'easeOut' }} />
          <motion.img src={Cactus2} alt="Map Cactus 2" className="cactus2"
                      initial={{ y: 25, opacity: 0 }} animate={{ y: 0, opacity: 1 }} 
                      transition={{ delay: 0.5, duration: 1, ease: 'easeOut' }} />
          <motion.img src={Page1DottedLine} alt="Page1 dotted line" className="p1-dotted-line"
                      initial={{ y: 25, opacity: 0 }} animate={{ y: 0, opacity: 1 }} 
                      transition={{ delay: 0.5, duration: 1, ease: 'easeOut' }} />
          <motion.img src={Grass} alt="Page1 grass icon" className="p1-grass"
                      initial={{ y: 25, opacity: 0 }} animate={{ y: 0, opacity: 1 }} 
                      transition={{ delay: 0.5, duration: 1, ease: 'easeOut' }} />
          <motion.img src={Compass} alt="Compass icon" className="compass"
                      initial={{ y: 25, opacity: 0 }} animate={{ y: 0, opacity: 1 }} 
                      transition={{ delay: 0.5, duration: 1, ease: 'easeOut' }} />

        <div className="trailer-wrapper d-flex flex-column align-items-center justify-content-center">
          
          <motion.img src={SkeletonFrame} alt="Skeleton Frame" className="skeleton-frame"
                      initial={{ scale: 0, opacity: 0 }} animate={{ scale: 1, opacity: 1 }}
                      transition={{ delay: 0.15, duration: 0.25, ease: 'easeOut' }}
          />

          
          <a href="https://youtu.be/GEHQamurmBI?si=I8-euk5_BwD9Zi6m" 
             target="_blank" rel="noopener noreferrer" style={{ cursor: 'pointer' }}
             onClick={() => trackTrailerClick('trailer')}>
            <motion.img
              src={TrailerRibbon} alt="Trailer Ribbon" className="trailer-ribbon"
              initial={{ scale: 0, opacity: 0 }} animate={{ scale: 1, opacity: 1 }}
              transition={{ delay: 0.3, duration: 0.25, ease: 'easeOut' }}
              onClick={() => {
                handlePress('playTrailer', 200);
                trackTrailerClick('trailer');
              }}
            />
          </a>
          
        </div>
        <p className='p1-text py-4'>Are You a Spurpunk?</p>
        <p className='myi my-3'>Meet Your Instructors!</p>
      </div> 

    </div>
  );
};

export default Page1;
